import React, { useState } from "react";
import { Form, TextInput, Button, Row, Col, Typo, useI18n } from "../../";
import Seperator from "../Seperator";
import { challengePassword, } from "../../hooks/useAuthenticator";
import StateHandler from "../StateHandler";
export default function ChallengePassword(props) {
    const { state, values, errors } = props.state;
    const setState = props.setState;
    const onChangeString = (field) => {
        return (value) => setState({
            ...props.state,
            values: { ...values, [field]: value || "" },
        });
    };
    const [secret, setSecret] = useState("");
    const i18n = useI18n(props.translationGroup);
    return (React.createElement(React.Fragment, null,
        React.createElement(Typo, { variant: "h2", margin: "none" }, i18n.get("new_password")),
        React.createElement(StateHandler, { state: state, onErrorReset: () => {
                setState({ ...props.state, state: "ok" });
            } },
            React.createElement(Form, { spacing: 8, vertical: true, horizontalAlign: "right", root: { left: 0, right: 0, top: 4, bottom: 16 }, onSubmit: (e) => e.preventDefault() },
                React.createElement(Typo, { variant: "info" }, i18n.get("enter_code_password_reset")),
                React.createElement(TextInput, { inline: true, label: "Email", name: "username", readOnly: true, value: values.email }),
                React.createElement(TextInput, { inline: true, label: i18n.get("code"), value: secret, onChange: (value) => {
                        setSecret(value || "");
                    }, error: errors.secret }),
                React.createElement(TextInput, { inline: true, password: true, label: i18n.get("new_password"), name: "new-password", value: values.password, onChange: onChangeString("password"), error: errors.password }),
                React.createElement(Button, { xs: "120px", primary: true, onClick: async () => {
                        const success = await challengePassword(props.state, setState, secret);
                        if (success)
                            setTimeout(() => props.onModeChange("login", true), 1000);
                    } }, i18n.get("change"))),
            React.createElement(Seperator, null),
            React.createElement(Row, { root: { top: 16 } },
                React.createElement(Col, null,
                    React.createElement(Button, { link: true, onClick: () => props.onModeChange("login") }, i18n.get("back_to_sign_in?")))))));
}
